
import dayjs from "dayjs"

export const clearTransactionFilterData = {
  SpId: null,
  TukId: null,
  SupId: null,
  TrnsTyp: null,
  TrnsDteSt: null,
  TrnsDteEn: null,
}

export const initTransactionFilterData = {
  ...clearTransactionFilterData,
  TrnsDteSt: dayjs().startOf("month").format("YYYY-MM-DD"),
  TrnsDteEn: dayjs().endOf("month").format("YYYY-MM-DD"),
}

export const initTransactionDialogData = {
  SpId: null,
  TrnsTyp: "I",
  TrnsDte: dayjs().format("YYYY-MM-DD"),
  Qty: 0,
  UntPr: 0,
  TotalPr: 0,
  TukId: null,
  SupId: null,
  DocNo: "",
  DocDte: null,
  Dscp: "",
  Rmk: "",
}
